<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="title"
    :cancel-btn="successMessage ? 'Закрыть' : 'Отменить'"
    successless
    @closed="$emit('closed')"
  >
    <v-overlay
      :value="isLoading"
      absolute
      color="white"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-overlay>

    <template v-if="!successMessage">
      <div class="ml-1 mb-2">
        <a v-if="fileTemplateUrl" :href="fileTemplateUrl" target="_blank">Скачать Шаблон файла</a>
      </div>
      <BFileUpload
        :value="file"
        :upload-file="uploadFile"
        :error-message="errorMessage"
      />
    </template>

    <div
      v-if="successMessage"
      v-html="successMessage"
    />

    <div
      v-else-if="errorMessage"
      class="error--text ml-8"
      v-text="errorMessage"
    />
  </BModalConfirm>
</template>

<script>
import { UsersApi } from '@/api/resources/UsersApi'
import { getErrorMessages } from '@/helpers/getErrorMessages'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BFileUpload from '@/components/forms/BFileUpload.vue'


const SUCCESS_MESSAGE = 'Файл будет обработан в фоновом режиме. Статус его обработки будет получен в уведомлениях системы.'

export default {
  name: 'UsersModalUploadPermissionsFile',
  components: {
    BModalConfirm,
    BFileUpload,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: 'Импорт прав ДК',
    },
    request: {
      type: Function,
      default: (...args) => {
        const api = new UsersApi()
        return api.importPermissions(...args)
      },
    },
    fileTemplateUrl: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isLoading: false,
    successMessage: null,
    errorMessage: null,
    file: null,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
        .then(() => !!this.successMessage)
    },
    close() {
      return this.$refs.modal.close()
    },
    async uploadFile(file) {
      this.errorMessage = null
      this.isLoading = true

      try {
        await this.request(file)
        this.successMessage = SUCCESS_MESSAGE
      } catch (e) {
        this.errorMessage = getErrorMessages(e).join(', ')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
